import Login from "./Login";

export const ProtectedRoute = ({ token, setToken, children }) => {
    if (!token) {
        // user is not authenticated
        return <Login setToken={setToken} />
    }
    return children;
};